var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-list-page"},_vm._l((_vm.cardList),function(item,index){return _c('div',{key:index,staticClass:"card-item",style:({
      backgroundImage: 'url(' + item.bg + ')',
      backgroundSize: 'cover',
    }),on:{"click":function($event){return _vm.toNextPage(item)}}},[_c('img',{staticClass:"img-ico",attrs:{"src":item.ico}}),_c('div',{staticClass:"item-title"},[_vm._v(_vm._s(item.certificateType))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }